import { HotelReservation, Pet } from '@monorepo/functions/src/types/reservations'
import { SpecialCondition } from '@monorepo/functions/src/types/special-conditions'

export const SPECIAL_CONDITIONS_MAP: { [key in SpecialCondition['type']]: SpecialCondition } = {
    medication: { type: 'medication', symbol: 'O', label: 'Medicación' },
    special_food: { type: 'special_food', symbol: '□', label: 'Comida especial' },
    no_bed: { type: 'no_bed', symbol: '△', label: 'Sin cama' },
    allergic: { type: 'allergic', symbol: 'A', label: 'Alérgico' },
    warning: { type: 'warning', symbol: '⚠', label: 'Warning' },
    escapist: { type: 'escapist', symbol: 'E', label: 'Escapista' },
    own_food: { type: 'own_food', symbol: '*', label: 'Pienso propio' },
    add_meat: { type: 'add_meat', symbol: '■', label: 'Añadir carne/lata' },
    own_can: { type: 'own_can', symbol: 'L', label: 'Lata propia' },
    little_food: { type: 'little_food', symbol: '-', label: 'Poco pienso' },
    more_food: { type: 'more_food', symbol: '+', label: 'Más pienso' },
    toy: { type: 'toy', symbol: '🧸', label: 'Juguete' },
    blanket: { type: 'blanket', symbol: '🧶', label: 'Manta' },
    bed: { type: 'bed', symbol: '🛏️', label: 'Cama' },
}

export const SPECIAL_CONDITIONS: SpecialCondition[] = Object.values(SPECIAL_CONDITIONS_MAP)

export const getAllSpecialConditions = (reservation: HotelReservation, pet: Pet, petIndex: number) => {
    const conditions = [
        ...(pet.conditions ?? []),
        ...(reservation.additionalServices.reduce((acc, service) => {
            if (!('petIndex' in service) || service.petIndex !== petIndex) {
                return acc // When service is not specific to a pet or is for another pet we don't add it to the conditions
            }
            if (service.type === 'medication') {
                acc.push(SPECIAL_CONDITIONS_MAP.medication)
            }
            if (service.type === 'special_food') {
                acc.push(SPECIAL_CONDITIONS_MAP.special_food)
            }
            return acc
        }, [] as SpecialCondition[])),
    ]
    return conditions
}
